import React, { FC } from 'react';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';
import styles from './lawyer_payment_components.module.scss';

type Props = { title: string; text: string };

export const LawyerPaymentFeeBlock: FC<Props> = ({ title, text }) => (
  <div className={styles.block}>
    <MaterialIcon name="done" className={styles.icon} />
    <span className={styles.title}>{title}</span> :
    <br />
    {text}
  </div>
);
